// export const LIGHT_COLORS = {
//     primary: "#F26E51",
//     secondary: "#FFAD87",
//     textPrimary: "#0e1014",
//     textSecondary: "#444",
//     buttonText: "#fff",
//     backgroundLight: "#f2ede7",
//     error: "#ef9a9a",
//     errorBorder: "#c62828",
//     success: "#a5d6a7",
//     successBorder: "#2e7d32",
//     border: "#e0e0e0",
// }

// export const DARK_COLORS = {
//     primary: "#F26E51",
//     secondary: "#FFAD87",
//     textPrimary: "#f5f5f5",
//     textSecondary: "#aaa",
//     buttonText: "#0e1014",
//     background: "#121212",
//     cardBackground: "#1e1e1e",
//     border: "#333",
//     error: "#ef9a9a",
//     errorBorder: "#c62828",
//     success: "#a5d6a7",
//     successBorder: "#2e7d32",
// };

export const LIGHT_COLORS = {
    primary: "#F26E51",
    secondary: "#FFAD87",
    textPrimary: "#0e1014",
    textSecondary: "#666",
    buttonText: "#fff",
    backgroundLight: "#f2ede7",
    background: "#fff",
    error: "#ef9a9a",
    errorBorder: "#c62828",
    success: "#a5d6a7",
    successBorder: "#2e7d32",
    border: "#e0e0e0",
    specialBG: "#986d39",
  
    // Additional UI Colors
    cardBackground: "#ffffff",
    cardHoverBackground: "#fff7f2",
    mutedText: "#777",
    imageBackground: "#f9f9f9",
    shadowColor: "rgba(0, 0, 0, 0.08)",
    footerBG: "#0e1014",
    danger: "#F44336",
    positive: "#66BB6A",
  };
  
//   export const DARK_COLORS = {
//     primary: "#F26E51",
//     secondary: "#FFAD87",
//     textPrimary: "#f5f5f5",
//     textSecondary: "#aaa",
//     buttonText: "#fff",
//     backgroundLight: "#f2ede7",
//     background: "#121212",
//     cardBackground: "#1e1e1e",
//     cardHoverBackground: "#2a2a2a",
//     border: "#333",
//     error: "#ef9a9a",
//     errorBorder: "#c62828",
//     success: "#a5d6a7",
//     successBorder: "#2e7d32",
//     specialBG: "#986d39",
  
//     mutedText: "#888",
//     imageBackground: "#222",
//     shadowColor: "rgba(255, 255, 255, 0.05)",
//     footerBG: "#0e1014",
//   };
export const DARK_COLORS = {
    primary: "#F26E51", // Accent
    secondary: "#FFAD87", // Accent lighter
    textPrimary: "#F5F5F5", // Light readable text
    textSecondary: "#B3B3B3", // Muted text
    buttonText: "#FFFFFF", // For buttons
    backgroundLight: "#1e1e1e", // Light sections/cards
    background: "#121212", // Main background with subtle gradient
    cardBackground: "#1A1A1A", // Card base
    cardHoverBackground: "#242424", // Card on hover
    border: "#2A2A2A", // Border on dark surfaces
    error: "#ef9a9a",
    errorBorder: "#c62828",
    success: "#a5d6a7",
    successBorder: "#2e7d32",
    specialBG: "#ab6604", // Stylish warm tone
    accent: "#ec4899",
  
    // Extras
    mutedText: "#888888",
    imageBackground: "#181818", // Placeholder backgrounds
    shadowColor: "rgba(0, 0, 0, 0.4)", // Slight elevation
    footerBG: "#1e1e1e", // Rich footer base
    danger: "#F44336",
    positive: "#66BB6A",
  };
  
  export const COLORS = DARK_COLORS;